import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgTriangleArrowRight = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      fillRule='evenodd'
      d='M13.017 18.159a1.5 1.5 0 0 1-.926-1.386V13.5H5.636a1.5 1.5 0 0 1 0-3h6.455V7.227a1.5 1.5 0 0 1 2.56-1.06l4.773 4.772a1.5 1.5 0 0 1 0 2.122l-4.773 4.773a1.5 1.5 0 0 1-1.634.325'
      clipRule='evenodd'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgTriangleArrowRight)
export default ForwardRef
